// extracted by mini-css-extract-plugin
export default {"CVChartContainer":"PollScoreChart_CVChartContainer__dw56c"};